import { forwardRef, ReactNode } from "react";

import Button from "components/Button";
import { FilterRemoveIcon } from "components/icons";

import { useTranslationContext } from "context/TranslationContext";
import cn from "lib/cn";

interface FilterPopOverprops {
  children?: ReactNode;
  title: string;
  submitButtonActive?: boolean;
  loading?: boolean;
  className?: string;
  hasValue?: boolean;
  height?: string;
  onClose?: () => void;
  onSubmitFilter: () => void;
  onResetFilter: () => void;
}

const FilterPopOver = forwardRef<HTMLDivElement, FilterPopOverprops>(
  (
    {
      children,
      title,
      submitButtonActive,
      loading,
      className,
      hasValue,
      height,
      onClose,
      onSubmitFilter,
      onResetFilter,
    },
    ref
  ) => {
    const { t } = useTranslationContext();

    return (
      <div
        className={cn(
          "w-[28rem] bg-white pt-3 pb-1 absolute z-10 border border-gray-20 rounded-lg shadow-lg right-0 top-12 -mr-[0.05rem]",
          className
        )}
      >
        <div className="flex items-center justify-between border-b border-gray-100 pt-2 pb-4 px-5">
          <div className="text-lg font-inter font-bold">{title}</div>

          <div
            onClick={
              hasValue !== undefined && hasValue ? onResetFilter : undefined
            }
            className={cn(
              "cursor-pointer p-1 px-2 rounded-full bg-primary-60 text-night text-xs flex gap-x-1 items-center",
              hasValue === false && "cursor-default opacity-60"
            )}
          >
            <FilterRemoveIcon width={15} height={15} />
            {t("clear_all_filter")}
          </div>
        </div>
        <div className="p-4 relative">
          <div
            ref={ref}
            className={cn(
              "relative h-[calc(100vh-25rem)] overflow-y-auto space-y-4",
              height
            )}
          >
            {children}
          </div>

          <div className="flex gap-x-2 pt-5">
            <Button
              onClick={onClose}
              color="primary"
              variant="outlined"
              className="flex-1"
            >
              {t("cancel")}
            </Button>
            <Button
              onClick={onSubmitFilter}
              color="primary"
              disabled={!submitButtonActive}
              isLoading={loading}
              className="flex-1"
            >
              {t("filter_now")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
);
export default FilterPopOver;
